import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// modules
import { EventsRoutingModule } from './events-routing.module';
import { SharedModule } from '../shared/shared.module';
import { LoginModule } from '../ez-login/ez-login.module';

// services

// components
import { VolunteerRegistrationComponent } from './volunteer-registration/volunteer-registration.component';
import { RegistrationComponent } from './registration/registration.component';
import { CoachRegistrationComponent } from './coach-registration/coach-registration.component';
import { TermsComponent } from './dummy-components/terms/terms.component';
import { WaiverComponent } from './dummy-components/waiver/waiver.component';
import { CompetitorRegistrationComponent } from './competitor-registration/competitor-registration.component';
import { SelectDivisionsComponent } from './competitor-registration/select-divisions/select-divisions.component';
import { VIPRegistrationComponent } from './vip-registration/vip-registration.component';
import { RefereeRegistrationComponent } from './referee-registration/referee-registration.component';
import { RegistrationClosedComponent } from './registration-closed/registration-closed.component';
import { RegistrationClosingWarningComponent } from './registration-closing-warning/registration-closing-warning.component';
import { PrefillFormComponent } from './prefill-form/prefill-form.component';
import { EventImageUploadComponent } from './event-image-upload/event-image-upload.component';
import { MasterRegistrationComponent } from './master-registration/master-registration.component';
import { OwnerRegistrationComponent } from './owner-registration/owner-registration.component';
import { VerifyUserComponent } from './verify-user/verify-user.component';
import { PaymentCodeModalComponent } from './payment-code-modal/payment-code-modal.component';
import { RegistrationPagePostcardComponent } from './registration/registration-page-postcard/registration-page-postcard.component';
import { RegistrationErrorComponent } from './registration-error/registration-error.component';
import { PayByUploadModalComponent } from './pay-by-upload-modal/pay-by-upload-modal.component';
import { SubmitProtestComponent } from './submit-protest/submit-protest.component';
import { DynamicRegistrationFormComponent } from './dynamic-registration-form/dynamic-registration-form.component';

@NgModule({
	imports: [CommonModule, EventsRoutingModule, SharedModule, LoginModule],
	declarations: [
		VolunteerRegistrationComponent,
		RegistrationComponent,
		TermsComponent,
		WaiverComponent,
		CoachRegistrationComponent,
		CompetitorRegistrationComponent,
		SelectDivisionsComponent,
		VIPRegistrationComponent,
		RefereeRegistrationComponent,
		RegistrationClosedComponent,
		RegistrationClosingWarningComponent,
		PrefillFormComponent,
		EventImageUploadComponent,
		MasterRegistrationComponent,
		OwnerRegistrationComponent,
		VerifyUserComponent,
		PaymentCodeModalComponent,
		RegistrationPagePostcardComponent,
		RegistrationErrorComponent,
		PayByUploadModalComponent,
		SubmitProtestComponent,
		DynamicRegistrationFormComponent,
	],
	providers: [],
})
export class EventsModule {}
